import { render, staticRenderFns } from "./dingd-listTc.vue?vue&type=template&id=258472a6&scoped=true"
import script from "./dingd-listTc.vue?vue&type=script&lang=js"
export * from "./dingd-listTc.vue?vue&type=script&lang=js"
import style0 from "./dingd-listTc.vue?vue&type=style&index=0&id=258472a6&prod&scoped=true&lang=css"
import style1 from "./dingd-listTc.vue?vue&type=style&index=1&id=258472a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258472a6",
  null
  
)

export default component.exports